<!------------------------------

      Page Actions

------------------------------->

<!-- no page actions -->

<!------------------------------

     Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.headlines.clients' | translate}}"
  [isInModalContext]="isInModalContext"
  [itemsData]="clients"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'clients'">

  <!------------------------------

    Filter Panel

  ------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

     Table Header

------------------------------->

  <ng-template #thead>

    <tr>
      <th class="table--sortable" (click)="toggleOrderDirection()">
        {{ 'lang.globals.name' | translate }}
        @if (orderDirection === 'desc') {
          <sb-icon
            icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
        } @else {
          <sb-icon
            icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>

  <!------------------------------

   Table Body

------------------------------->

  <ng-template #tbody let-item>
    <tr>
      <td>
        <sb-comp-image-name-wrapper [image]="item?.primaryCompany?.logo?.url">
          <span firstLine>{{ item?.primaryCompany?.name }}</span>
          <span secondLine>{{ item?.id }}</span>
        </sb-comp-image-name-wrapper>
      </td>
      <td class="tr bw sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="item.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(item, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>

  <!------------------------------

Card Element

------------------------------->


  <!--  No Card Element -->
</sb-table-wrapper-new>
